module.exports = __webpack_public_path__ + "fonts/Rubik-400-cyrillic-ext65.f2f7a74.woff2";